import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'localizedDate',
    standalone: false
})
export class LocalizedDatePipe implements PipeTransform {

  private arabicDigits = ['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];

  constructor(private datePipe: DatePipe, private translate: TranslateService) {}

  transform(value: any, format: string,): string {
    const lang = this.translate.currentLang;
    const formatted = this.datePipe.transform(value, format, lang);
    if (!formatted) return '';
    
    if (lang === 'ar') {
      return formatted.replace(/\d/g, d => this.arabicDigits[+d]);
    }

    return formatted;
  }
}
